/* eslint-disable camelcase */
interface Theme {
  theme_name: string
  theme_detail: string
}

interface InfoItems {
  name?: string
  iconPath?: string
}

export class HorizontalInfoCardModel {
  background?: string = ''
  created_at?: string = ''
  deleted_at?: string | null = null
  description?: string = ''
  end_date?: string = ''
  format?: string = ''
  id?: number = -1
  image?: string = ''
  is_published?: number = 1
  link?: string = ''
  name?: string = ''
  organizer?: string = ''
  place?: string = ''
  reg_date_end?: string | null = null
  reg_date_start?: string | null = null
  slug?: string = ''
  start_date: string = ''
  theme?: Theme[] | null = null
  tag?: string = ''
  infoItems?: InfoItems[] = []
  updated_at?: string = ''
}
